/* eslint-disable */
import React, {Component} from 'react'
import '../../style/loader.css'

class Loader extends Component {
  render() {
    return (
      <>
        {this.props.show ? (
          <div className="loader-section">
            <img src={require('../../image/Comp-1.gif')} />
          </div>
        ) : null}
      </>
    )
  }
}

export default Loader
